import React from "react";
import { Row, Col } from "antd";
import { guniHelpUrl } from "constant/constant";
import styles from "components/Authentication/Common/auth.module.css";

const Footer = () => {
  return (
    <Row type="flex" align="bottom" justify="center" className="mt-3 ml-2">
      <Col>
        By continuing to create your account and use Guni services , you are agreeing to our{" "}
        <a href="https://www.gunisms.com.au/terms-of-service" target="_blank" className={styles.linkHover}>
          {" "}
          <span className="text-info-auth">Terms of Service </span>
        </a>{" "}
        and{" "}
        <a className={styles.linkHover} href="https://www.gunisms.com.au/privacy-policy" target="_blank">
          {" "}
          <span className="text-info-auth">Privacy Policy </span>
        </a>
        .
      </Col>
      {/* <Col span={8} md={4} className="text-center">
        <a href={guniHelpUrl} target="_blank"    className={styles.linkHover}>
          <span className="text-muted">Help</span>
        </a>
      </Col>
      <Col span={8} md={4} className="text-center">
        <a
          href="https://www.gunisms.com.au/privacy-policy"
          target="_blank"
          className={styles.linkHover}
        >
          <span className="text-muted">Privacy</span>
        </a>
      </Col>
      <Col span={8} md={4} className="text-center">
        <a
          href="https://www.gunisms.com.au/terms-of-service"
          target="_blank"
          className={styles.linkHover}
        >
          <span className="text-muted">Terms</span>
        </a>
      </Col> */}
    </Row>
  );
};

export default Footer;
